<template>
    <customHeader v-if="!examNames" title="오답노트" path="note" />
    <q-page-container v-show="!examNames" class="bg_color_gray_100" style="height: 100vh">
        <q-scroll-area visible style="height: 100%">
            <div class="page__wrap">
                <div class="filter__wrap">
                    <div style="flex: 0 0 auto">
                        <!-- {{ isSAT }} -->
                        <CusButton :type="!isSAT ? 570 : 580" :label="`레슨학습 오답노트`" @onReturn="onClickNoteType(false)" />
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <CusButton :type="isSAT ? 570 : 580" :label="`수능모의평가 오답노트`" @onReturn="onClickNoteType(true)" />
                        <!-- <CusButton  v-if="isSAT"  :type="580" :label="`수능모의평가2`" @onReturn=" onClickNoteType(false) " /> -->

                        <!-- <CqBtn unelevated rounded label="맞춤학습 오답노트"   style="white-space: nowrap" :class="isSAT ? 'btn__select' : 'btn'"
              @onClickFn="() => { onClickNoteType(false) }" />
            <CqBtn unelevated rounded label="수능모의평가 오답노트"   style="white-space: nowrap" class="mg_left_24" :class="!isSAT ? 'btn__select' : 'btn'"
              @onClickFn="() => { onClickNoteType(true) }" /> -->
                    </div>
                    <div v-if="!isSAT">
                        <div v-if="!isDisableSelect">
                            <CusButton
                                :type="472"
                                :label="`필터 선택`"
                                @onReturn="
                                    () => {
                                        popFilter = true;
                                    }
                                "
                            />
                            <!-- <CqBtn label="필터 선택" class="btn__filter" icon="img:/assets/images/icon/icon_filter.svg"
              @onClickFn="() => { modal = !modal }">
            </CqBtn> -->
                        </div>
                        <div v-if="isDisableSelect">
                            <div class="nocontent_filter">
                                <div style="font-size: 1.2vw; font-weight: 700; margin-left: 0.8vw">필터 선택</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="title">오답노트 목록</div>
                <!-- <q-infinite-scroll @load="onLoad" :offset="250" ref="scrollTargetRef"> -->
                <div v-if="!isSAT && data">
                    <q-card
                        v-for="card in data"
                        flat
                        class="my-card"
                        :onClick="
                            () => {
                                onClickItem(card);
                            }
                        "
                    >
                        <q-item>
                            <q-item-section>
                                <div class="my-card__section b2 line_height_42">
                                    <!-- TODO: 태그 들어가는 위치 -->
                                    <div class="my-card__section__first-column">
                                        <div class="chip">
                                            <q-chip :style="'background-color:' + learningTypeForWrongList[card.learningType]?.color + ';'">
                                                <b>
                                                    {{ learningTypeForWrongList[card.learningType]?.label }}
                                                </b>
                                            </q-chip>
                                        </div>
                                        <div style="flex: 0 0 auto; text-align: center; max-width: 150px; font-weight: 700">
                                            {{ card?.passageArea }}
                                        </div>
                                    </div>
                                    <div style="width: 100%">
                                        <div class="row" style="width: 100%; padding: 8px 0">
                                            <div class="color_gray_600" style="text-align: center; display: inline-flex; align-items: center; width: 8%; max-width: 100px">{{ card?.level }}레벨</div>
                                            <div class="" style="align-items: center; margin-left: 1.5vw; width: 12vw; white-space: nowrap; text-overflow: ellipsis; overflow: hidden">
                                                {{ card?.passageList[0].passageOrder }}-
                                                {{ card?.passageList[0].passageClass }}
                                            </div>
                                            <div style="overflow: hidden; width: 62%; max-width: 35.5vw; padding-left: 20px; white-space: nowrap; text-overflow: ellipsis">
                                                {{ card?.passageList[0].passageName }}
                                            </div>
                                        </div>
                                        <div class="row" style="width: 100%; padding: 8px 0">
                                            <div class="color_gray_600" style="text-align: center; display: inline-flex; align-items: center; width: 8%; max-width: 100px">{{ card?.lesson }}레슨</div>
                                            <div class="" style="align-items: center; margin-left: 1.5vw; width: 12vw; white-space: nowrap; text-overflow: ellipsis; overflow: hidden">
                                                {{ card?.passageList[1].passageOrder }}-
                                                {{ card?.passageList[1].passageClass }}
                                            </div>
                                            <div style="overflow: hidden; width: 62%; max-width: 35.5vw; padding-left: 20px; white-space: nowrap; text-overflow: ellipsis">
                                                {{ card?.passageList[1].passageName }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </q-item-section>
                            <q-card-actions class="note__card">
                                <p class="b2 medium color_gray_600 note__txt" style="display: inline-flex; align-items: center; margin-bottom: 0">
                                    오답노트 <span style="color: #18b73f; font-weight: 700; margin: 0px 4px">{{ card.completeCnt }}회</span> 완료!
                                    <span class="note__img"><img src="@/assets/images/icon/ico_party.svg" /></span>
                                </p>
                                <q-btn flat round class="caption3 color_gray_500" icon="arrow_forward_ios" />
                            </q-card-actions>
                        </q-item>
                    </q-card>
                </div>
                <div v-if="isSAT && data">
                    <q-card
                        v-for="card in data"
                        flat
                        class="my-card b2 line_height_42"
                        :onClick="
                            () => {
                                onClickItem(card);
                            }
                        "
                    >
                        <q-item>
                            <q-item-section>
                                <q-item-label class="bold color_tertiary">
                                    수능모의평가
                                    <span class="regular color_gray_600" style="margin-left: 3.33vmin"> {{ card.level }}레벨 {{ card.passageOrder }}회 </span>
                                </q-item-label>
                            </q-item-section>
                            <q-card-actions class="note__card">
                                <p class="b2 medium color_gray_600 note__txt" style="display: inline-flex; align-items: center; margin-bottom: 0">
                                    오답노트 <span class="color_primary bold" style="margin: 0px 4px">{{ card.completeCnt }}회</span> 완료!
                                    <span class="note__img"><img src="@/assets/images/icon/ico_party.svg" /></span>
                                </p>
                                <q-btn flat round class="caption3 color_gray_500" icon="arrow_forward_ios" />
                            </q-card-actions>
                        </q-item>
                    </q-card>
                </div>
                <div v-if="!isLoading && data.length === 0" style="align-items: center; display: grid" class="noData__content">
                    <div style="text-align: center">
                        <p class="null__content">
                            <img src="@/assets/images/icon/ico_contents_null.png" alt="none content" />
                        </p>
                        <!-- <p class="h2 regular color_gray_600 mg_bottom_70"  > -->
                        <!-- 열심히 잘하고 있어요!<br /> -->
                        <!-- 아직은 풀이할 오답노트가 없어요. -->
                        <!-- </p> -->
                        <div v-html="noDataMsgHtml" class="h2 regular color_gray_600 mg_bottom_70"></div>
                        <CqBtn
                            unelevated
                            color="primary"
                            label="학습 홈으로 이동"
                            class="btn__home caption2"
                            style="width: 35%; max-width: 533px; padding: 2.58vmin 6.1vmin; border-radius: 1vmin; font-size: 1.2vw"
                            @on-click-fn="
                                () => {
                                    onClick('learninghome');
                                }
                            "
                        />
                    </div>
                </div>
                <LoadingCard :is-show="isLoading" />
                <!-- <template v-slot:loading>
            <div class="row justify-center q-my-md">
              <q-spinner-dots color="primary" size="40px" />
            </div>
          </template> -->
                <!-- </q-infinite-scroll> -->
            </div>
        </q-scroll-area>
    </q-page-container>

    <!-- <q-dialog v-model="modal" class="modal">
    <q-card class="modal__wrap">
      <q-card-section class="row items-center q-pb-none">
        <q-space />
        <q-btn class="close" icon="close" flat round dense v-close-popup />
      </q-card-section>
      <q-separator />
      <div class="modal__content">
        <div class="title">
          <div class="line_height_38">
            <b>
              레벨 선택
            </b>
          </div>
          <q-btn flat label="필터초기화" class="btn__filter" style=" border: 1px solid #8E8E8E;" :onClick="onClickClear" />
        </div>
        <q-checkbox class="modal__checkbox" v-model="levelAll" label="모든레벨" :onClick="() => { onClickAll('level') }" />
        <q-option-group inline v-model="levelFilters" :options="levelOptions" color="primary" type="checkbox"
          class="modal__checkbox" />
        <q-separator style="margin-top: 2.6vmin;" />
        <div class="title">
          <div class="line_height_38">
            <b>
              갈래/주제 선택
            </b>
          </div>
        </div>
        <q-checkbox class="modal__checkbox" v-model="classAll" label="모든영역"
          :onClick="() => { onClickAll('passage') }" />
        <q-option-group inline v-model="classFilters" :options="classOptions" color="primary" type="checkbox"
          class="modal__checkbox" />
      </div>

      <q-card-actions align="center" class="mg_bottom_32">
        <CqBtn class="btn__submit" color="primary" style="width: 50%;" label="필터 적용" @keydown.enter="onClickSetFilter"
          @click="onClickSetFilter" />
      </q-card-actions>
    </q-card>
  </q-dialog> -->

    <q-dialog v-model="popFilter" class="modal">
        <q-card class="modal__wrap">
            <q-card-section class="row items-center q-pb-none">
                <q-space />
                <q-btn class="close" icon="close" flat v-close-popup />
            </q-card-section>

            <q-separator />

            <div class="modal__content">
                <div class="level-select">
                    <div class="flex justify-between align-center">
                        <h3 class="title">레벨 선택</h3>
                        <q-btn unelevated no-ripple :onClick="onInitFilter">
                            <span class="button small black-outline">필터초기화</span>
                        </q-btn>
                    </div>
                    <!-- 상단_체크박스 -->
                    <div class="flex justify-between align-center">
                        <CusCheck :id="isAll1.label" :label="isAll1.label" v-model:checked="isAll1.checked" @onReturn="onAll1" />
                        <template v-for="(e, i) in cbList1" :key="i">
                            <CusCheck :id="e.label" :label="e.label" v-model:checked="e.checked" />
                        </template>
                    </div>
                </div>
                <div class="subject-select">
                    <h3 class="title">갈래/주제 선택</h3>
                    <!-- 하단_체크박스 -->
                    <CusCheck :id="isAll2.label" :label="isAll2.label" v-model:checked="isAll2.checked" @onReturn="onAll2" />
                    <div class="flex align-center">
                        <template v-for="(e, i) in cbList2" :key="i">
                            <CusCheck :id="e.label" :label="e.label" v-model:checked="e.checked" />
                        </template>
                    </div>
                </div>
                <!-- 하단버튼 -->
                <p class="button__content">
                    <CusButton :type="560" :label="`필터 적용`" @onReturn="onClickSetFilter" />
                </p>
            </div>
        </q-card>
    </q-dialog>
    <template v-if="examNames">
        <Study :exam-names="examNames" :learning-type="learningType" :expr-version="studyStore?.exprVersion" @close="close" :type="isSAT ? 'SAT' : 'NORMAL'" />
    </template>
</template>

<script setup>
import { getWrongList, getSatList } from '@/api/modules/note';
import * as zzApi from '@/api/modules/note';
import customHeader from '@/components/layouts/header/header.vue';
import SiderLayer from '@/components/layouts/sider/siderLayer.vue';
import CqBtn from '@/components/quasar/cqBtn.vue';
import { classList, element, headerEtcCd01 } from '@/helpers/qbankParser/qbankMeta';
import { historyBack, useLocalLog } from '@/helpers/utils';
import { StudyStore } from '@/store/modules/study';
import { ref, watch, onMounted, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import Study from './study.vue';
import _ from 'lodash';
import { useQuasar, QSpinnerFacebook } from 'quasar';
import LoadingCard from '@/components/quasar/loadingCard.vue';
import CusButton from '@/components/widget/CusButton.vue';
import CusCheck from '@/components/widget/CusCheck.vue';
import { monitoringLog } from '@/api/modules/monitoring';
import { learningTypeForWrongList } from '@/helpers/qbankParser/qbankMeta';

const $q = useQuasar();
const router = useRouter();
const route = useRoute();
const isSAT = ref(false);
const isLoading = ref(false);
const modal = ref(false);
const levelFilters = ref([]);
const levelAll = ref(false);
const classAll = ref(false);
const classFilters = ref([]);
const scrollTargetRef = ref(null);
const data = ref([]);
const classOptions = Object.entries(classList).map(([key, value]) => {
    return { label: value, value: key };
});
const studyStore = StudyStore();

const isFilterSelectedAll = ref(false);

const examNames = ref(null);
let learningType = ref('');

const levelOptions = [...Array(3)].map((i, index) => {
    return { label: index + 1 + '레벨', value: index + 1 };
});
const noDataMsgHtml = computed(() => {
    return `아직은 풀이할 ${isSAT.value ? '수능모의평가' : '맞춤학습'} 오답노트가 없어요. <br/> ${isSAT.value ? '수능모의평가를' : '맞춤학습을'} 진행한 후에 오답노트가 제공되어요.`;
});

const sampleData = [
    {
        level: 1,
        lesson: 1,
        passageArea: '문학',
        completeCnt: 0,
        passageList: [
            {
                passageOrder: '지문 2',
                passageClass: '현대시',
                passageName: '가는 길',
                examName: 'KRT_01_01_L_02',
            },
            {
                passageOrder: '지문 1',
                passageClass: '현대시',
                passageName: '풀잎',
                examName: 'KRT_01_01_L_01',
            },
        ],
    },
    {
        level: 1,
        lesson: 1,
        passageArea: '문학',
        completeCnt: 0,
        passageList: [
            {
                passageOrder: '지문 2',
                passageClass: '현대시',
                passageName: '가는 길',
                examName: 'KRT_01_01_L_02',
            },
            {
                passageOrder: '지문 1',
                passageClass: '현대시',
                passageName: '풀잎',
                examName: 'KRT_01_01_L_01',
            },
        ],
    },
];

const close = () => {
    examNames.value = null;
    // 바로 조회시 횟수증가가 반영안되서 딜레이줌
    setTimeout(() => {
        getData();
    }, 800);
};

const onClick = (pg) => {
    router.push('/' + pg);
};

const onClickClear = () => {
    // classFilters.value = [];
    // levelFilters.value = [];
    levelFilters.value = levelOptions.map((item) => {
        return item.value;
    });
    classFilters.value = classOptions.map((item) => {
        return item.value;
    });
};

const onClickAll = (type) => {
    // console.log(type)
    if (type === 'level') {
        if (levelAll.value) {
            levelFilters.value = levelOptions.map((item) => {
                return item.value;
            });
        } else {
            levelFilters.value = [];
        }
    }
    if (type === 'passage') {
        if (classAll.value) {
            classFilters.value = classOptions.map((item) => {
                return item.value;
            });
        } else {
            classFilters.value = [];
        }
    }
};

const onClickNoteType = (isSat) => {
    // testIndex = 0;
    data.value = [];
    isSAT.value = isSat;
    getData();
    // scrollTargetRef.value.resume();
    // scrollTargetRef.value.poll();
};

const onClickSetFilter = () => {
    data.value = [];
    // modal.value = false;
    popFilter.value = false;
    getData();
    // scrollTargetRef.value.poll();
    // scrollTargetRef.value.resume();
    // scrollTargetRef.reset();
    // scrollTargetRef.stop();
};

const onClickItem = (item) => {
    let tmpexamNames = [];
    if (item) {
        if (isSAT.value) {
            tmpexamNames.push(item.examName);
            examNames.value = tmpexamNames;
        } else {
            item.passageList.map((i) => {
                tmpexamNames.push(i.examName);
            });

            examNames.value = _.sortBy(tmpexamNames, 'examName');
            log && console.log('==최상위 examNames : ', examNames.value);
            learningType = item.learningType;
            // console.log('learningTypes : ', learningType);
            // getNoteProblemList(
            //   {
            //     examNameCsv: (examNames).toString()
            //   }, (rs) => {

            //   })
        }
    }
};

/*NOTE: LOG 셋팅, local 일때만 로그 */
let log = useLocalLog();

const getData = async () => {
    // data.value.push(...sampleData);
    // $q.loading.show({
    //   spinnerColor: 'grey-6',
    //   spinnerSize: 140,
    //   backgroundColor: 'white',
    // })
    isLoading.value = true;
    if (isSAT.value) {
        getSatList({}, (rs) => {
            //
            data.value = rs;
            // $q.loading.hide()
            isLoading.value = false;
        });
    } else {
        const selector1 = cbList1.value.filter((e) => e.checked).map((e) => e.value);
        const selector2 = cbList2.value.filter((e) => e.checked).map((e) => e.value);

        isFilterSelectedAll.value = selector1.length === 3 && selector2.length === 12;
        // console.log('--getData selector1--',selector1)
        // console.log('--getData selector2--',selector2)
        // getWrongList(   {   levelParamList: (levelFilters.value).toString(),   classList: (classFilters.value).toString()  },

        /* KRT-1413 */
        const res = await zzApi.getWrongList2({ levelParamList: selector1.toString(), classList: selector2.toString() });
        if (res && res.status === 200) {
            const rs = res.data.data;
            let tmpData = [];
            rs.forEach((element) => {
                tmpData.push({ ...element, passageList: _.sortBy(element?.passageList, 'examName') });
            });
            data.value = tmpData;
            // $q.loading.hide();
            isLoading.value = false;
        }

        // getWrongList({ levelParamList: selector1.toString(), classList: selector2.toString() }, (rs) => {
        //     let tmpData = [];
        //     rs.forEach((element) => {
        //         tmpData.push({ ...element, passageList: _.sortBy(element?.passageList, 'examName') });
        //     });
        //     data.value = tmpData;
        //     // $q.loading.hide();
        //     isLoading.value = false;
        // });
    }
};

let testIndex = 0;
const onLoad = (index, done) => {
    // console.log('onLoad');
    setTimeout(() => {
        // let tmpData = sampleData.map(item => { return { ...item, name: item.name + idx } });
        // idx += 1;
        data.value.push(...sampleData);
        testIndex++;
        if (testIndex > 3) {
            scrollTargetRef.value.stop();
        }
        done();
    }, 1000);
};

watch(cbList1, (val) => {
    // console.log('watch', val);
});

watch(
    () => levelFilters.value,
    (newValue) => {
        if (newValue?.length === levelOptions.length) {
            levelAll.value = true;
        } else {
            levelAll.value = false;
        }
    },
);
watch(
    () => classFilters.value,
    (newValue) => {
        if (newValue?.length === classOptions.length) {
            classAll.value = true;
        } else {
            classAll.value = false;
        }
    },
);

onMounted(() => {
    getData();
    levelFilters.value = levelOptions.map((item) => {
        return item.value;
    });
    classFilters.value = classOptions.map((item) => {
        return item.value;
    });

    let data = {
        menuName: 'note',
    };
    monitoringLog(data, (res) => {
        console.log('wrongNote monitoringLog API response ===', res);
    });
});

//---------------필터다이얼로그_START----------------//
//---------------상단----------------//
const popFilter = ref(false);
const isAll1 = ref({ checked: true, value: '1', label: '모든 레벨' });
const onAll1 = (bool) => {
    cbList1.value.forEach((e) => (e.checked = bool));
};
const cbList1 = ref([
    { checked: true, value: '1', label: '1레벨' },
    { checked: true, value: '2', label: '2레벨' },
    { checked: true, value: '3', label: '3레벨' },
]);
watch(cbList1.value, (nObj) => {
    isAll1.value.checked = nObj.filter((e) => e.checked).length === nObj.length;
});

//---------------하단----------------//
const isAll2 = ref({ checked: true, value: '1', label: '모든 영역' });
const onAll2 = (bool) => {
    cbList2.value.forEach((e) => (e.checked = bool));
};
const cbList2 = ref([
    { checked: true, value: 'Y1_01', label: '현대시' },
    { checked: true, value: 'Y1_02', label: '현대소설' },
    { checked: true, value: 'Y1_03', label: '고전시가' },
    { checked: true, value: 'Y1_04', label: '고전산문' },
    { checked: true, value: 'Y1_05', label: '극수필' },
    { checked: true, value: 'Y5_01', label: '인문' },
    { checked: true, value: 'Y5_02', label: '과학' },
    { checked: true, value: 'Y5_03', label: '정치사회' },
    { checked: true, value: 'Y5_04', label: '예술' },
    { checked: true, value: 'Y5_05', label: '기술' },
    { checked: true, value: 'Y5_06', label: '경제문화' },
    { checked: true, value: 'Y5_07', label: '융합' },
]);
watch(cbList2.value, (nObj) => {
    isAll2.value.checked = nObj.filter((e) => e.checked).length === nObj.length;
});

const onInitFilter = () => {
    onAll1(true);
    onAll2(true);
};

const isDisableSelect = computed(() => {
    return !isLoading.value && data.value.length === 0 && isFilterSelectedAll.value;
});

//---------------필터다이얼로그_END----------------//
</script>

<style scoped lang="scss">
.page__wrap {
    height: 100%;
    background-color: #fafafa;
    padding: 5.33vmin 7vmin 3.33vmin;
}

.filter__wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .btn,
    .btn__select {
        padding: 1.58vmin 3.33vmin;
        border: 1px solid $color_gray_900;
        @include border-radius(3.33vmin);
        font-size: 1.2vw;
        line-height: 1.6vw;
    }

    .btn {
        color: $color_white;
        background: $color_gray_900;
    }

    .btn__select {
        color: $color_gray_900;
    }
}

.btn__filter {
    padding: 0.5vmin 3.33vmin 0.5vmin 2.5vmin;
    border: 1px solid $color_gray_900;
    @include border-radius(1.33vmin);
    font-size: 1.2vw;
    line-height: 1.6vw;
}

.title {
    color: #222222;
    font-size: 1.8vw;
    font-weight: 700;
    line-height: 2.6vw;
    margin: 4.5vmin 0 2.5vmin;
}

.my-card {
    border: 1px solid #e0e0e0;
    background: #fff;
    border-radius: 1vmin;
    padding: 3.1vmin 4.2vmin;
    margin: 1vmin 0;

    .my-card__section {
        width: 100%;
        display: inline-flex;
        align-items: center;
        .my-card__section__first-column {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            /* background-color: red; */
            height: 100%;
            margin-right: 8vmin;
        }
    }
}

.btn__home {
    width: 44.42vmin;
    height: 8.17vmin;
    font-size: 1.2vw;
    line-height: 1.6vw;
    font-weight: 700;
}

// .modal {
//   .title {
//     color: #222222;
//     font-size: 1.5vw;
//     font-weight: 700;
//     margin: 4.08vmin 0vmin 2.92vmin;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//   }

//   &__wrap {
//     width: 50vw;
//     min-width: 500px;
//     max-width: 1000px;
//     border-radius: 2.5vmin;
//   }

//   &__content {
//     padding: 0vmin 3.5vmin 2vmin;
//   }

//   &__checkbox ::v-deep {
//     // font-size: 1.1vw;
//     font-size: 1.3vw;
//     line-height: 2.1vw;
//     font-weight: 400;
//     // padding: 1.13vmin 0;
//   }

//   .q-option-group ::v-deep {
//     .q-checkbox__inner {
//       font-size: 2vw;
//     }

//     .q-checkbox__bg {
//       width: 1.5vw;
//       height: 1.5vw;
//       border-radius: 50% !important;
//     }
//   }

//   .q-checkbox ::v-deep {
//     .q-checkbox__inner {
//       font-size: 2vw;
//     }

//     .q-checkbox__bg {
//       width: 1.5vw;
//       height: 1.5vw;
//       border-radius: 50% !important;
//     }
//   }

//   .btn {
//     border-radius: 1vmin;
//     margin-bottom: 2vmin;
//   }

//   .close {
//     margin: 1.5vmin;
//     font-size: 1.2vw;
//   }

//   .q-option-group {
//     ::v-deep>div {
//       width: 23%;
//     }
//   }

//   .btn__filter {
//     color: #000000;
//     font-weight: 700;
//     border: 2px solid #8E8E8E;
//     border-radius: 1.33vmin;
//     font-size: 1.2vw;
//     padding: 1.17vmin 2.04vmin;
//   }

//   .btn__submit {
//     width: 41.67vmin;
//     height: 8.17vmin;
//     font-size: 1.2vw;
//     line-height: 1.6vw;
//     border-radius: 1.33vmin;
//   }
// }

.modal {
    p {
        margin-bottom: 0;
    }
    .q-dialog__inner--minimized > div {
        // width: 55%;
        // max-width: 1072px;
        width: 53.6vw;
        max-width: inherit;
        @include border-radius(2vw);
    }

    .modal__content {
        // padding: 2.45vw 2.8vw 2vw;
        padding: 4.08vmin 2.8vw 3.33vmin;
    }

    .q-card__section--vert {
        // padding: 1.65vw 2.8vw;
        padding: 2.75vmin 2.8vw;
    }

    .close {
        width: 2.4vw;
        height: 2.4vw;
        min-height: inherit;
        padding: 0;
        font-size: 1.2vw;
    }
    .align-center {
        align-items: center;
    }

    .title {
        margin: 0;
        font-size: 1.5vw;
        font-weight: 700;
        line-height: 1.9vw;
    }
    .level-select {
        > .flex {
            // margin-bottom: 2.4vw;
            margin-bottom: 4.08vmin;
        }
        .q-btn {
            padding: 0;
        }

        .input__box {
            width: 7.75vw;
        }
    }

    .subject-select {
        // margin-top: 3vw;
        // padding-top: 3vw;
        margin-top: 5vmin;
        padding-top: 5vmin;
        border-top: 1px solid $color_gray_400;

        .title {
            // margin-bottom: 2.4vw;
            margin-bottom: 4.08vmin;
        }
        .flex .input__box {
            // margin-top: 1.25vw;
            margin-top: 2vmin;
            margin-right: 2vw;
            width: 7.6vw;
        }
        .flex .input__box:nth-of-type(5),
        .flex .input__box:nth-of-type(10) {
            margin-right: 0;
        }
    }

    .button__content {
        width: 25vw;
        // margin: 3vw auto 0;
        margin: 5vmin auto 0;
    }
}
::v-deep {
    .q-checkbox {
        padding: 1.13vmin 0;

        &__label {
            margin-left: 1.67vmin;
        }
    }

    .note__card {
        button {
            margin-left: 2.33vmin;
        }

        .q-icon {
            font-size: 1.2vw;
            color: $color_gray_500;
        }
    }

    .filter__wrap {
        .block {
            font-weight: 700;
        }

        .q-icon {
            width: 2.4vw;
            height: 2.4vw;
            margin-right: 0;

            img {
                width: 1.33vw;
                height: 1.31vw;
                margin: 0 auto;
            }
        }
    }

    .noData__content {
        margin-top: 9.5vmin;

        .q-btn {
            .block {
                font-size: 1.2vw;
                font-weight: 700;
                line-height: 1.6vw;
            }
        }
    }

    .q-btn__content {
        .block {
            font-weight: 500;
        }
    }

    .btn__filter {
        .q-btn__content {
            .block {
                font-weight: 700;
            }
        }
    }

    .q-scrollarea__bar--v,
    .q-scrollarea__thumb--v {
        width: 0.3vw;
    }
}

.note__img {
    width: 2.5vw;
    height: 2.5vw;
    line-height: 0;

    img {
        width: 100%;
    }
}

.null__content {
    width: 10%;
    max-width: 180px;
    margin: 0 auto;
    line-height: 0;

    img {
        width: 100%;
    }
}

.nocontent_filter {
    width: 12vw;
    position: relative;
    height: 3vw;
    padding: 0.65vw 1.95vw 0.65vw 3.5vw;
    background: $color_gray_400;
    color: $color_gray_500;
    border-radius: 1vw;
    display: flex;
    flex-direction: row;
    justify-content: center;
}
.nocontent_filter::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 2.6vw;
    width: 1.6vw;
    height: 1.6vw;
    background: url('@/assets/images/icon/ico_filter_nocontent.svg') no-repeat center/ contain;
    @include transform(translateY(-50%));
}
</style>
